// extracted by mini-css-extract-plugin
module.exports = {"root":"_11N5z","social":"J2PqE","hr":"_2Drqq","backy":"_4jZD_"};